import { INTERFACE_BASE_URL, API_SECRET } from "./config";
import Axios from "axios";
import { instance as Loading } from "@/plugins/loading/";
import { instance as Toast } from "@/plugins/toast/";
import $localStorage from "@/utils/localStorage";
import JSMD5 from "md5";
const axiosInstance = Axios.create({
	baseURL: INTERFACE_BASE_URL
});

const qyUserInfo = $localStorage.get("qyUserInfo") || {};

axiosInstance.interceptors.request.use(
    config => {
        if (!config.noLogin && !qyUserInfo.UserId) {
            return Promise.reject({
                data: {
                    errcode: "401",
                    errmsg: "未登录，请重新登录"
                }
            });
        }
        let dataString = API_SECRET;
        // 如果有data
        if (config.data) {
            dataString = JSON.stringify(config.data) + API_SECRET;
        }
        let sign = JSMD5(dataString);
        config.headers.sign = sign;
        if (!config.noLoading) {
            Loading.show();
        }
        console.info("request config:");
        console.log(config);
	    return config;
    }, error => {
        console.error("request error:");
        console.error(error);
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(response => {
	console.info("response data:");
	console.info(response);
	let data = response.data;
	if (!response.config.noLoading) {
		Loading.hide();
	}
	if (!response.config.noToast) {
		if (data.errcode != 0 && data.errmsg) {
			Toast.show(data.errmsg);
		}
	}
	return data;
}, error => {
	console.error("response error:");
	console.error(error);
	// 重新登录
	if (error.data && error.data.errcode == "401") {
        let url = encodeURIComponent(window.location.href); //callback url
        let link = encodeURIComponent(`${window.location.origin}/qyLogin.html`); //get code url
        // appid=wx0f63648d3ce25ce4
        // state 参数不被编译，直接返回
        window.location.replace( `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0f63648d3ce25ce4&redirect_uri=${link}&response_type=code&scope=snsapi_userinfo&agentid=0&state=${url}#wechat_redirect`)
		 return Promise.reject(error);
	}
	if (!error.config.noLoading) {
		Loading.hide();
	}
	if (!error.config.noToast && error.response.data && error.data.errmsg) {
		Toast.show(error.response.data.errmsg)
	}
	return Promise.reject(error);
});

export default axiosInstance;